import { airbrake } from 'shared'

export async function copyTextToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text)
  } catch(error) {
    airbrake.notify({ error: error, message: 'Failed to copy text to clipboard' });
  }
}
